module.exports = __webpack_public_path__ + "static/media/laptop.60326b82.png";